import { getVariantFromId as _getVariantFromId } from "@input-output-hk/essential-cardano-utils";

const variants = ["a", "b", "c"] as const;
export const getGlossaryVariantFromId = (_id: string) =>
  _getVariantFromId(_id, variants);
